export default "__VITE_ASSET__DQYjy7xi__"